import React from 'react';
import warning from "../../../../common/assets/icons/warning.svg";
import styles from './WarningNote.module.scss';

export interface WarningNoteProps {
  label: React.ReactNode,
  text: React.ReactNode
}

const WarningNote = ({label, text}: WarningNoteProps) => {

  return (
    <div className={styles.noteContainer}>
      <div className={styles.iconWarningContainer}>
        <img src={warning} alt="warning" className={styles.iconWarning}/>
      </div>
      <div className={styles.label}>{label}</div>
      <div className={styles.text}>{text}</div>
    </div>
  )
};

export default WarningNote;
